import { render, staticRenderFns } from "./rgtx.vue?vue&type=template&id=216e6375&scoped=true"
import script from "./rgtx.vue?vue&type=script&lang=js"
export * from "./rgtx.vue?vue&type=script&lang=js"
import style0 from "./rgtx.vue?vue&type=style&index=0&id=216e6375&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216e6375",
  null
  
)

export default component.exports